import React, { useState, useEffect, useRef } from "react";
import { updateDoc, doc } from "firebase/firestore";
import { db } from "./firebase";
import "./MillionaireGame.css";
import { BlockMath } from "react-katex";
import "katex/dist/katex.min.css";
import Confetti from "react-confetti";


const MillionaireHostView = ({ gameId, gameData }) => {
  // Treat a string as LaTeX if it contains common LaTeX cues
const isLatex = (s) =>
  typeof s === "string" && /\\|\\frac|\\left|\\right|\$/.test(s);

    const normalizeAnswer = (answer) => {
        if (!answer) return "";
        return answer
          .replace(/\\pounds/g, "£") // Convert LaTeX £ to symbol
          .replace(/\\frac{(\d+)}{(\d+)}/g, (_, num, denom) => `${num}/${denom}`) // optional: handle \frac
          .replace(/\\ /g, "") // remove backslash space
          .replace(/\s+/g, "") // strip all spaces
          .trim();
      };
  const currentQuestionIndex = gameData.currentQuestionIndex;
  const questions = gameData.selectedQuestions || [];
  const currentQuestion = questions[currentQuestionIndex - 1];
  const [isRevealed, setIsRevealed] = useState(false);
  const [showLeaderboard, setShowLeaderboard] = useState(false);
  const [eliminatedPlayers, setEliminatedPlayers] = useState([]);
  const [showNextButton, setShowNextButton] = useState(false);
  const winAudioRef = useRef(null);
  const activePlayers = Object.entries(gameData.players || {}).filter(([id, p]) => {
    if (p.gameOver || p.tookMoney) return false;
  
    const lastIndex = p.lastAnsweredIndex;
    const lastAnswer = p.answer;
    const lastQuestion = questions[lastIndex - 1];
    
      

    if (!isRevealed) return true;
  
    // If revealed: only keep if they answered correctly
    return normalizeAnswer(lastAnswer) === normalizeAnswer(lastQuestion?.correctAnswer);

  }).length;
  

  const totalAnswered = Object.values(gameData.players || {}).filter(
    (p) => typeof p.answer === "string" && p.lastAnsweredIndex === currentQuestionIndex
  ).length;
  const [showCelebration, setShowCelebration] = useState(false);
  const [winners, setWinners] = useState([]);
  
  const moneyLadder = [
    "£100", "£200", "£300", "£500", "£1,000",
    "£2,000", "£4,000", "£8,000", "£16,000", "£32,000",
    "£64,000", "£125,000", "£250,000", "£500,000", "⭐£1 MILLION⭐"
  ];

  const [volume, setVolume] = useState(0.1);

  const roundAudioRef = useRef(null);
  const correctSoundRef = useRef(null);

  useEffect(() => {
    if (roundAudioRef.current) {
      roundAudioRef.current.volume = volume;
      roundAudioRef.current.src = getRoundMusic(currentQuestionIndex - 1);
      roundAudioRef.current.load();
      roundAudioRef.current.play().catch((err) => {
        console.warn("Autoplay error:", err.message);
      });
    }
  }, [currentQuestionIndex]);
  useEffect(() => {
    // Whenever the question changes, hide the leaderboard
    setShowLeaderboard(false);
    setIsRevealed(false);
    setEliminatedPlayers([]);
  }, [currentQuestionIndex]);
  

  const getRoundMusic = (index) => {
    if (index < 5) return "/Millionaire/Round1.mp3";
    if (index < 10) return "/Millionaire/Round2.mp3";
    return "/Millionaire/Round3.mp3";
  };

  const handleRevealAnswer = async () => {
    setIsRevealed(true);
  
  const eliminated = Object.entries(gameData.players || {}).filter(([id, p]) => {
  if (p.gameOver || p.tookMoney) return false;

  const lastIndex = p.lastAnsweredIndex;
  const lastAnswer = p.answer;
  const lastQuestion = questions[lastIndex - 1];

  // ❌ Eliminate if:
  // 1. They never answered this question
  // 2. OR their answer is wrong
  if (lastIndex !== currentQuestionIndex) return true; // no answer
  return normalizeAnswer(lastAnswer) !== normalizeAnswer(lastQuestion?.correctAnswer);
}).map(([id]) => id);

  
    setEliminatedPlayers(eliminated);
  
    // Mark eliminated players as gameOver in Firestore
    for (const playerId of eliminated) {
      await updateDoc(doc(db, "liveGames", gameId), {
        [`players.${playerId}.gameOver`]: true,
      });
    }
  
    // Play the correct sound
    if (correctSoundRef.current) {
      correctSoundRef.current.currentTime = 0;
      correctSoundRef.current.volume = volume;
      correctSoundRef.current.play();
    }
    setShowNextButton(false);
    await updateDoc(doc(db, "liveGames", gameId), {
      revealedAt: Date.now(),
      revealedQuestionIndex: currentQuestionIndex,
    });
  // 🕒 Delay showing "Next Question" button by 3 seconds
setTimeout(() => {
    setShowNextButton(true);
  }, 3000);
  
    // 🕒 Delay leaderboard display by 5 seconds
    setTimeout(() => {
      setShowLeaderboard(true);
    }, 3000);
    if (currentQuestionIndex === 15) {
        const remaining = Object.entries(gameData.players || {}).filter(([id, p]) => {
          const lastIndex = p.lastAnsweredIndex;
          const lastAnswer = p.answer;
          const lastQuestion = questions[lastIndex - 1];
      
          return !p.gameOver && !p.tookMoney && lastIndex === 15 && lastAnswer === lastQuestion?.correctAnswer;
        }).map(([_, p]) => p.name || "Player");
      
        setWinners(remaining);
       if (roundAudioRef.current) {
  roundAudioRef.current.pause(); // ⛔ Stop background music
}

if (winAudioRef.current) {
  winAudioRef.current.currentTime = 0;
  winAudioRef.current.volume = volume;
  winAudioRef.current.play().catch((e) => {
    console.warn("Win audio failed to play:", e.message);
  });
}

          
        setTimeout(() => {
            
          setShowCelebration(true);
        }, 3000);
      }
      
  };
  
  
  
  

  const handleNext = async () => {
    setIsRevealed(false);
    setEliminatedPlayers([]);
    await updateDoc(doc(db, "liveGames", gameId), {
      currentQuestionIndex: currentQuestionIndex + 1,
      revealedQuestionIndex: null,
    });
  };
  
  

  if (!currentQuestion) {
    return (
      <div className="millionaire-wrapper">
        <h2 style={{ color: "#ffeaa7" }}>Waiting for host to start the game...</h2>
      </div>
    );
  }

  const correctText = currentQuestion.correctAnswer;

  return (
    <div className="millionaire-wrapper">
      <audio ref={roundAudioRef} />
      <audio ref={correctSoundRef} src="/Millionaire/correct2.mp3" preload="auto" />
      <audio ref={winAudioRef} src="/Millionaire/win.mp3" preload="auto" />

      <div className="game-layout">
        <div className="question-block animated">
          <div style={{
            position: "absolute",
            top: "1rem",
            right: "1rem",
            backgroundColor: "#1c3a6b",
            color: "#fff",
            padding: "0.75rem 1.25rem",
            borderRadius: "2rem",
            fontWeight: "bold",
            fontSize: "1rem",
            boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            lineHeight: "1.4",
            textAlign: "center",
            minWidth: "160px"
          }}>
            <div>✅ {activePlayers} active player{activePlayers !== 1 ? "s" : ""}</div>
            <div>👥 {totalAnswered} answered</div>
          </div>
          {showLeaderboard && (
  <div className="leaderboard-overlay">
    <div className="leaderboard-box" style={{ position: "relative" }}>
      <button
        className="close-leaderboard-btn"
        onClick={() => setShowLeaderboard(false)}
        style={{
          position: "absolute",
          top: "1px",
          right: "257px",
          background: "transparent",
          color: "#fff",
          fontSize: "1.4rem",
          border: "none",
          cursor: "pointer",
          zIndex: 1
        }}
        aria-label="Close leaderboard"
      >
        ×
      </button>

      <h2>📋 Leaderboard</h2>


      <ul>
      {Object.entries(gameData.players || {})
  .filter(([id, player]) => {
    // Show only currently active players OR those just eliminated this round
    const wasJustEliminated = eliminatedPlayers.includes(id);
    const stillIn = !player.gameOver && !player.tookMoney;
    return wasJustEliminated || stillIn;
  })
  .map(([id, player]) => {
    const eliminated = eliminatedPlayers.includes(id);
    const lifelinesUsed = player.lifelinesUsed?.[currentQuestionIndex] || {};

    return (
        <li
        key={id}
        className={`leaderboard-player ${eliminated ? "eliminated" : "survivor"}`}
      >
        <span style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
  <span style={{ fontWeight: "bold", color: "#00f5d4" }}>
    {player.name || `Player ${id}`}
  </span>
  <span>
    {eliminated ? "❌ Eliminated" : "✅ Safe"}
  </span>

  {/* Lifeline icons */}
  <span style={{ display: "flex", gap: "0.25rem", alignItems: "center" }}>
    {player.lifelinesUsed?.fiftyFifty && (
      <img
        src="https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2F50-50.gif?alt=media&token=4453e297-63ec-4e3d-9be2-9716a38f580f"
        alt="50:50"
        style={{ height: "24px" }}
      />
    )}
    {player.lifelinesUsed?.askClassmate && (
      <img
        src="https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2FAsk%20a%20Classmate.png?alt=media&token=296bf1a7-dfb2-474a-8540-91854577697d"
        alt="Ask a Classmate"
        style={{ height: "24px" }}
      />
    )}
    {player.lifelinesUsed?.askClass && (
      <img
        src="https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2FAsk%20The%20Audience.gif?alt=media&token=45572f27-6256-47b0-ad60-883b9486542b"
        alt="Ask the Class"
        style={{ height: "24px" }}
      />
    )}
  </span>
</span>


      </li>
      
    );
  })}

      </ul>
      <button
        className="start-btn"
        style={{ marginTop: "1.5rem" }}
        onClick={handleNext}
      >
        Continue
      </button>
    </div>
  </div>
)}


          <h2>Question {currentQuestionIndex}</h2>
          <div className="question-content" style={{ textAlign: "center" }}>
{Array.isArray(currentQuestion.paragraphs) && currentQuestion.paragraphs.length > 0 ? (
  currentQuestion.paragraphs.map((p, i) => (
    <div key={i} style={{ marginBottom: "1rem" }}>
      {typeof p === "string" ? (
        isLatex(p) ? <BlockMath math={p} /> : <p>{p}</p>
      ) : (
        <>
          {p.text && (isLatex(p.text) ? <BlockMath math={p.text} /> : <p>{p.text}</p>)}
          {p.image && (
            <img
              src={p.image}
              alt={`Part ${i + 1}`}
              style={{
                maxWidth: "90%",
                maxHeight: "180px",
                objectFit: "contain",
                border: "1px solid #ccc",
                borderRadius: "6px",
                margin: "0.5rem auto",
                display: "block",
              }}
            />
          )}
        </>
      )}
    </div>
  ))
) : (
  <>
    {currentQuestion.questionText &&
      currentQuestion.questionText.split("\n").map((line, idx) =>
        isLatex(line) ? (
          <BlockMath key={idx} math={line} />
        ) : (
          <p
            key={idx}
            style={{
              marginBottom: "0.75rem",
              fontSize: "1.5rem",
              lineHeight: "1.6",
              fontWeight: "500",
            }}
          >
            {line}
          </p>
        )
      )}

 {currentQuestion.questionLatex && (
  <div style={{ display: "flex", justifyContent: "center" }}>
    <BlockMath math={currentQuestion.questionLatex} />
  </div>
)}


    {currentQuestion.optionalQuestionText && (
      isLatex(currentQuestion.optionalQuestionText)
        ? <BlockMath math={currentQuestion.optionalQuestionText} />
        : <p style={{ marginTop: "0.5rem", fontWeight: "bold" }}>
            {currentQuestion.optionalQuestionText}
          </p>
    )}
  </>
)}

</div>




          <div className="options-grid">
         {currentQuestion.options.map((opt, i) => {
  const isCorrect = opt.isCorrect;
  return (
    <button
      key={i}
      className={`option-btn ${isRevealed && isCorrect ? "correct" : ""}`}
      disabled
    >
      {isLatex(opt.text) ? <BlockMath math={opt.text} /> : opt.text}
    </button>
  );
})}



          </div>

          {!isRevealed ? (
  <button
    onClick={handleRevealAnswer}
    className="start-btn"
    style={{ marginTop: "2rem" }}
  >
    Reveal Answer
  </button>
  
) : showNextButton ? (
  <button
    onClick={handleNext}
    className="start-btn"
    style={{ marginTop: "2rem" }}
  >
    Next Question
  </button>
) : null}


          <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
            <label style={{ color: "#ffeaa7", fontSize: "1rem", marginRight: "0.5rem" }}>
              🎵 Volume:
            </label>
            <input
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={volume}
              onChange={(e) => {
                const newVolume = parseFloat(e.target.value);
                setVolume(newVolume);
                if (roundAudioRef.current) {
                  roundAudioRef.current.volume = newVolume;
                }
              }}
              style={{ width: "150px" }}
            />
          </div>
        </div>

        <div className="money-ladder">
  {[...moneyLadder].reverse().map((amount, i) => {
    const level = moneyLadder.length - 1 - i;
    const isActive =
      currentQuestionIndex > 1 && level === currentQuestionIndex - 2;
    return (
      <div
        key={i}
        className={`ladder-step ${isActive ? "active-step" : ""}`}
      >
        {amount}
      </div>
    );
  })}
</div>
{showCelebration && (
  <div style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.9)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    color: "#fff",
    textAlign: "center",
    padding: "2rem"
  }}>
    <Confetti />
    <h1 style={{ fontSize: "3rem", color: "#feca57", marginBottom: "1.5rem" }}>
      🥳 JACKPOT WINNER{winners.length > 1 ? "S" : ""} 🥳
    </h1>
    {winners.map((name, i) => (
      <h2 key={i} style={{
        fontSize: "2.5rem",
        margin: "0.5rem 0",
        fontWeight: "bold",
        textShadow: "2px 2px #000"
      }}>
        {name}
      </h2>
    ))}
  </div>
)}

      </div>
    </div>
    
  );
};

export default MillionaireHostView;
